import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import variablePie from "highcharts/modules/variable-pie.js";
import Sunburst from "highcharts/modules/sunburst.js";

// Keep track of initialized modules to prevent re-initialization
const initializedModules = {};

const Chart = ({ options }) => {
  // Initialize the required module based on chart type
  if (!initializedModules["sunburst"]) {
    Sunburst(Highcharts);
    initializedModules["sunburst"] = true;
  }

  return (
    <HighchartsReact
      highcharts={Highcharts}
      constructorType="chart"
      options={options}
    />
  );
};

export default Chart;
